import type { TableWidgetData } from '@/features/_shared/widget-registry';
import type { MarketApps } from '@/features/dashboard';

export function buildTemplate(data: TableWidgetData): MarketApps {
  return [
    {
      id: `ai-chat-apps-${data.tool_call_id}`,
      tabs: [
        {
          id: `ai-chat-table-${data.tool_call_id}`,
          name: 'Data Table',
          type: 'table',
          metadata: {
            start_date: data.metadata?.start_date ?? '',
            end_date: data.metadata?.end_date ?? ''
          },
          sections: [
            {
              name: '',
              rows: data.rows.map(row => ({
                shortTitle: row.title,
                symbol: {
                  key: {
                    Code: row.code,
                    PeriodType: row.period_type,
                    Period: '1',
                    TimeRef: row.time_ref?.toString() ?? ''
                  },
                  group: 'Prod_Indexes'
                },
                diffSymbol: {
                  key: { Code: '', PeriodType: '', Period: '', TimeRef: '' },
                  group: 'Prod_Indexes'
                }
              }))
            }
          ]
        }
      ]
    }
  ];
}
